import type { NavigationGuard, RouteConfig, } from 'vue-router';
import { multiGuard, } from '~/utils/vue-router-multiguard';

function loadNavigationGuard(name: keyof typeof import('./route-guards')): NavigationGuard {
	return (to, from, next) => {
		import('./route-guards').then((a) => {
			a[name](to, from, next);
		});
	};
}

export const MoveOutRoutes: RouteConfig[] = [
	{
		path: '/close-account',
		component: () => import(/* webpackChunkName: "chunk-your-account-move-out" */'./pages/master.vue').then((m) => m.default),
		beforeEnter: multiGuard([loadNavigationGuard('LoadDetails'), loadNavigationGuard('RequiresCanMoveOut'),]),
		children: [
			{ path: `move-out-date`, name: `CloseAccountMoveOutDate`, component: () => import(/* webpackChunkName: "chunk-your-account-move-out" */'./pages/move-out-date.vue').then((m) => m.default), beforeEnter: loadNavigationGuard('RequiresMoveOutDetails'), },
			{ path: `your-final-bill`, component: () => import(/* webpackChunkName: "chunk-your-account-move-out" */'./pages/your-final-bill.vue').then((m) => m.default), beforeEnter: loadNavigationGuard('RequiresMoveOutDetails'), },
			{ path: `forwarding-address`, component: () => import(/* webpackChunkName: "chunk-your-account-move-out" */'./pages/forwarding-address.vue').then((m) => m.default), beforeEnter: loadNavigationGuard('RequiresMoveOutDetails'), },
			{ path: `check-details`, component: () => import(/* webpackChunkName: "chunk-your-account-move-out" */'./pages/check-details.vue').then((m) => m.default), beforeEnter: multiGuard([loadNavigationGuard('RequiresMoveOutDetails'), loadNavigationGuard('RequiresForwardingAddress'),]), },
			{ path: `success`, component: () => import(/* webpackChunkName: "chunk-your-account-move-out" */'./pages/move-out-success.vue').then((m) => m.default), },
			{ path: `successful`, component: () => import(/* webpackChunkName: "chunk-your-account-move-out" */'./pages/move-out-success.vue').then((m) => m.default), },
			{ path: '', redirect: 'move-out-date', name: 'CloseAccount', },
			{ path: `pay-final-bill/payment`, component: () => import('./pages/payment-detail.vue').then((m) => m.default), },
			{ path: `pay-final-bill/success`, component: () => import('./pages/payment-success.vue').then((m) => m.default), },
			{ path: `pay-final-bill/error/payment`, component: () => import('./pages/payment-failure.vue').then((m) => m.default), },
			{ path: `pay-final-bill/error/system`, component: () => import('./pages/system-failure.vue').then((m) => m.default), },
			{ path: `pay-final-bill/pending`, component: () => import('./pages/payment-pending.vue').then((m) => m.default), },
		],
	},
];
